import React, { memo, useEffect, Suspense, lazy, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import 'iframe-resizer';
import { useParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import { Rates } from "rate-quotes";
import LeadCaptureForm from '../../components/LeadCaptureForm/';
import Classes from '../Homepage//index.module.css';
import styled from 'styled-components';
import AOS from "aos";
import MediaQuery from "react-responsive";
import "aos/dist/aos.css";
import Rectangleonimagemobile from '../../components/GameOnQuotes/images/Rectangleonimagemobile.png';
import useSunWestSuccessYears from '../../utils/useSunWestSuccessYears';
import FormModal from '../../components/FormModal/FormModal';
import MloRateQuotes from "./MloRateQuotes/index";
import useFetch from "../../utils/useFetch"

const GameOnQuotes = React.lazy(() => import('../../components/GameOnQuotes/Loadable'));
const LoHome = lazy(() => import('../LoHome/LoBanner/LoBanner'));
const BorrowerLeadForm = lazy(() => import('../../components/BorrowerLeadForm'));
const ResourcesMenu = lazy(() => import('../../components/ResourcesMenu'));
const FeaturesDiv = lazy(() => import('../../components/FeaturesDiv'));
const ServicesDiv = lazy(() => import('../../components/ServicesDiv'));
const VideoCarousel = lazy(() => import('../../components/RealStories/RealStories'));
const TestimonialsDiv = lazy(() => import('../../components/Testimonials'));
const UserWayAccessibilityMenu = lazy(() => import('../../components/UserWayAccessibilityMenu'));

AOS.init();

const key = 'Home';

// Move the styled component definition outside of the component
const QuoteWrapper = styled.div`
  .react-multi-carousel-dot--active button {
    background: #083f88 !important;
    width: 25px !important;
    border-radius: 10px !important;
  }

  @media (max-width: 991.7px) {
    .react-multi-carousel-dot--active button {   
        margin-bottom:0rem;
    }
  }

  @media (min-width: 320px) and (max-width: 389.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 17px !important;
    }
  }

  @media (min-width: 390px) and (max-width: 767.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 17px !important;
    }
  }

  @media (min-width: 768px) and (max-width: 991.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0.5px;
      width: 11px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 13px !important;
    }
  }

  @media (min-width: 992px) and (max-width: 1100px) {
    .react-multi-carousel-dot button {
      margin-right: 2px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 20px !important;
    }
  }
`;

const Homepage = ({ }) => {

  const imgCDNURL = process.env.REACT_APP_LOWRATES_RESOURCES;
  const successYears = useSunWestSuccessYears();

  const [showModal, setShowModal] = useState(false);
  const [loanType, setLoanType] = useState('https://www.swmc.com/angelai/conversation/');
  const [workflowUrl, setWorkflowUrl] = useState('');
  const [defaultTab, setDefaultTab] = useState('refinance');
  const [purchaseSubTab, setPurchaseSubTab] = useState('fha')
  const { loName } = useParams();

  const data = useFetch(`https://${loName}.sunwestmortgage.com/includes/${loName}.json`);
  const loId = data?.[0]?.loID || null;


  const handleOpenModal = () => {
    setShowModal(true);
    const isPurchaseTabActive = document.querySelector('#loan-purpose-tabs-tab-purchase')?.classList.contains('active');
    if (isPurchaseTabActive) {
      setWorkflowUrl('https://www.swmc.com/angelai/conversation/3467ea4d9ea851616ed32ab8e7196d863532d20aae076681f7f4dddb69bfb311')
    } else {
      setLoanType("https://www.swmc.com/angelai/conversation/")
      setWorkflowUrl('')
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (location.search.includes('home-equity')) {
      setDefaultTab('purchase');
      setPurchaseSubTab('homeEquity');
    }
  }, [location]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const iframe = document.getElementById('iframeContactUs');

    if (iframe) {
      window.iFrameResize(
        {
          log: false,
          checkOrigin: false,
          autoResize: true,
          heightCalculationMethod: 'bodyScroll',
        },
        iframe
      );
    }
  }, []);

  useEffect(() => {
    const dynamicPaths = [
      '/about-us',
      '/conventional-loans',
      '/dscrheloc',
      '/fha-loans',
      '/investment-loans',
      '/jumbo-loans',
      '/renovation-loans',
      '/refinance',
      '/reverse-mortgage',
      '/va-loans',
      '/terms',
      '/privacy',
      '/faq',
      '/home-buying',
      '/refinancing-guide',
      '/documents',
      '/contact',
      '/sitemap',
      '/mortgage-process',
      '/disclaimers'
    ];

    const path = location.pathname;
    const isLoPage = /^\/[^/]+$/.test(path) && !dynamicPaths.includes(path);

    if (isLoPage) {
      // Extract the LO ID from the pathname (e.g., '/john' → 'john')
      const lofId = loId;
      if (lofId) {
        sessionStorage.setItem('lofID', lofId);
      }
    } else {
      sessionStorage.removeItem('lofID');
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (data === null) {
    return <div />
  } else if (loName !== null && data === null) {
    return <div />
  }

  return (
    <article>
      <Helmet>
        <title>Choose LowRates | Experience Ai-Powered Fair and Fast Lending</title>
        <meta
          name="description"
          content="Secure low mortgage rates with Kurt Huels. Get fast approvals, expert guidance, and stress-free home financing. Apply now!"
        />
        <meta
          name="keywords"
          content="low mortgage rates, lowrates, low rates, home loans, refinance, first-time homebuyer, fast mortgage approval, Kurt Huels, loan officer, mortgage expert, best mortgage rates, AngelAi, borrower, homebuying, mortgage, Ai, homebuying assistance, mortgage calculator, loan products"
        />
      </Helmet>
      <div id="ratesWrapperLo" className='shadow-lg'>
        <Container >
          <Row >
            <Col xs={12} sm={12} md={6} xl={6} lg={6} className={Classes.leftBannerDiv}>
              <Suspense fallback={<div>Loading...</div>}>
                <MediaQuery maxWidth={767} >
                  <UserWayAccessibilityMenu color="white" width={50} height={50} />
                </MediaQuery>
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                <div id="loRate">
                  <MloRateQuotes data={data} />
                </div>
              </Suspense>
              {/* <div className={Classes.btn_div_apply}>
                <button className={Classes.apply_now_btn}  onClick={handleOpenModal}>Apply Now</button>
              </div> */}

              {/* <h5 className={Classes.getFair}>Get fair and trusted offers every time. AngelAi is built by a family business with over {successYears} years of passion and commitment to help you.</h5> */}
              <FormModal
                show={showModal}
                onHide={handleCloseModal}
                loanType={loanType}
                workflowUrl={workflowUrl}
              />
            </Col>
            {/* <img
              src={Rectangleonimagemobile}
              className={`${Classes.imagewrappermobile} px-0`}
            /> */}
            <Col xs={12} sm={12} md={6} xl={6} lg={6} className={Classes.rightBannerDiv} id="right-banner-div">
              <LoHome data={data} />
            </Col>
          </Row>
        </Container>

      </div>


      <div className={Classes.formContainer}>
        {/* <iframe
          id="iframeContactUs"
          src=" https://prod-cdn.swmc.com/react/contactUs/index.html"
          allow="geolocation"
          frameBorder="0"
          scrolling="no"
          style={{ width: '100%', border: '0' }}
        ></iframe> */}
        {/* <Suspense fallback={<div>Loading...</div>}>
          <BorrowerLeadForm />
        </Suspense> */}
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <ResourcesMenu />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <FeaturesDiv />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <ServicesDiv />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <VideoCarousel />
      </Suspense>
      <QuoteWrapper >
        <Suspense fallback={<div>Loading...</div>}>
          <TestimonialsDiv />
        </Suspense>
      </QuoteWrapper>
    </article>
  )
}

export default Homepage;